import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { generateCacheKey, withManualCache, DEFAULT_CACHE_TTL } from '@/utlility/cache-service';
const API_URL = process.env.NEXT_PUBLIC_API_URL;

export const fetchPaginatedFeedbacks = createAsyncThunk(
  'feedbacks/fetchPaginatedFeedbacks',
  async ({ organization_key, section_slug, slug, page = 1, limit = 9 }, { rejectWithValue }) => {
    try {
      const url = `${API_URL}/api/page-section-data`;
      const payload = { organization_key, section_slug, slug, page, limit };
      const cacheKey = generateCacheKey(url, 'GET', payload);
      return await withManualCache(cacheKey, async () => {
        const queryParams = new URLSearchParams(payload).toString();
        const urlWithParams = `${url}?${queryParams}`;
        const response = await fetch(urlWithParams, {
          method: "GET",
          next: { revalidate: DEFAULT_CACHE_TTL },
        });
        return await response.json();
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Unknown error';
      return rejectWithValue({ message: errorMessage });
    }
  }
);


const FeedbacksSlice = createSlice({
  name: 'feedbacks',
  initialState: {
    feedbacks: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchPaginatedFeedbacks.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.feedbacks = action.payload.data.data;
    });

  },
});

export default FeedbacksSlice.reducer;
